import { action, observable, computed } from 'mobx';

import { CROSS_SELL_GROUP_ID } from '../../../constants/constants';
import { log } from '../../../utils/console.js';
import { getSiteTypeByURL } from '@pes-ui/components/dist/collection/globals/utils/helpers';
// PESV3-29052 [FE] [My products page - RM migration] Update APIs for store
import { getRelatedProductsStore } from './RelatedProductsStore';

// * @typedef {import('../../../../services/related-products-store').RelatedProductsStore} RelatedProductsStore

/**
 * @typedef {import('../../../types').RelatedProductsGroupInfo} RelatedProductsGroupInfo
 */

const DEFAULT_GROUP_INDEX = 0;

export class RelatedSectionStore {
  /** @type {string} */
  @observable selectedGroupId = null;

  /** @type {RelatedProductsStore} */
  relatedProductsStore;

  /** @type {RelatedProductsGroupInfo[]} */
  relatedGroups = [];

  /** @type { { [groupId: string]: boolean } } */
  groupInitializedMap = {};

  localeObj = {};

  /**
   * @param {string} productSkuId
   * @param {*} rootStore
   * @param {*} localeObj
   */
  constructor(productSkuId, rootStore, localeObj) {
    this.productSkuId = productSkuId;
    this.rootStore = rootStore;
    this.localeObj = localeObj;
    this.relatedProductsStore = getRelatedProductsStore(productSkuId, getSiteTypeByURL(), localeObj);
  }

  @computed get products() {
    if (this.groupInitializedMap[this.selectedGroupId]) {
      return this.relatedProductsStore.getProductsGroup(this.selectedGroupId).products;
    }

    return [];
  }

  @computed get isReady() {
    return !!this.selectedGroupId && this.relatedGroups.length > 0;
  }

  /**
   * @param {string} groupId
   */
  @action.bound
  setGroupId(groupId) {
    if (!this.groupInitializedMap[groupId]) {
      const productsGroup = this.relatedProductsStore.getProductsGroup(groupId);

      productsGroup.products.forEach((product) => {
        this.rootStore.relatedRootStore.createRelatedProductStore(product, groupId);
      });

      this.groupInitializedMap[groupId] = true;
    }

    this.selectedGroupId = groupId;
  }

  /** Initialize store */
  @action
  initStore() {
    return this.relatedProductsStore
      .getRelatedGroups()
      .then(({ info }) => {
        if (info.length === 0) {
          return;
        }

        const filteredGroups = info.filter(({ groupId }) => groupId !== CROSS_SELL_GROUP_ID);

        if (filteredGroups.length === 0) {
          return;
        }

        const { groupId } = filteredGroups[DEFAULT_GROUP_INDEX];

        this.relatedGroups = filteredGroups;
        this.setGroupId(groupId);
      })
      .catch(log.error);
  }
}
